export const CHART_INCOME = 'Income';
export const CHART_EXPENSES = 'Expenses';
export const CHART_TRANSFERS = 'Internal Transfers';
export const CHART_INVESTMENTS_PROPERTY = 'Investments (Property)';
export const CHART_INVESTMENTS_FINANCE = 'Investments (Finance)';
export const CHART_MORTGAGE_LUMP = '3GD Mortgage lump-sum';
export const CHART_REFUNDS = 'Refunds';
export const CHART_REVERTED = 'Reverted';
export const CHART_UNKNOWN = 'Unknown';
export const CHART_NA = 'N/A';

export const DEFAULT_OMHE_CATEGORY_GROUPS: Record<string, string> = {
  Groceries: 'Living',
  'Groceries (Emergency)': 'Living',
  Dining: 'Living',
  Alcohol: 'Living',
  Cafe: 'Living',
  Household: 'Living',
  Digital: 'Living',
  Software: 'Business',
  'Sole Trader expense': 'Business',
  Clothing: 'Living',
  Medical: 'Living',
  'Medical (Natural)': 'Living',
  Therapy: 'Living',
  Wellness: 'Living',
  Pharmacy: 'Living',
  Pets: 'Living',
  'Health & Fitness': 'Living',
  'Sports & Leisure': 'Living',
  Crafting: 'Living',
  'Hobbies & Interests': 'Living',
  Gifts: 'Living',
  Books: 'Living',
  'Night Out': 'Living',
  Entertainment: 'Living',
  Charity: 'Living',
  School: 'Living',
  Retreats: 'Living',
  'Extra Curricular': 'Children',
  Drama: 'Children',
  'Music lessons': 'Children',
  'Family Fun': 'Children',
  'Family Outing': 'Children',
  Fuel: 'Transport',
  Transport: 'Transport',
  'Public Transport': 'Transport',
  Parking: 'Transport',
  Tolls: 'Transport',
  'Car Hire': 'Transport',
  'Car Rental': 'Transport',
  Taxis: 'Transport',
  'Vehicle maintenance': 'Transport',
  Travel: 'Travel',
  'Health insurance': 'Insurance',
  'Other insurance': 'Insurance',
  'Property fees': 'Housing',
  LPT: 'Housing',
  'LPT (3GD)': 'Housing',
  'LPT (19Abb)': 'Investments (Property)',
  'LPT (51LC)': 'Investments (Property)',
  Mortgage: 'Housing',
  'Mortgage (19Abb)': 'Investments (Property)',
  'Mortgage (51LC)': 'Investments (Property)',
  'Property fees (51LC)': 'Investments (Property)',
  'Property fees (19Abb)': 'Investments (Property)',
  'Other Expenses (19Abb)': 'Investments (Property)',
  'Other Expenses (51LC)': 'Investments (Property)',
  'Other Expenses': 'Investments (Property)',
  'Home Maintenance': 'Housing',
  'Mobile phone': 'Housing',
  Postage: 'Housing',
  'Utilities: Electricity': 'Housing',
  'Utilities: Gas': 'Housing',
  'Utilities: Water': 'Housing',
  'Utilities: Refuse': 'Housing',
  'Utilities: Broadband': 'Housing',
  'Utilities: TV licence': 'Housing',
  Utilities: 'Housing',
  'Bank fees': 'Finance',
  'Cash ATM': 'Finance',
  FX: 'Finance',
  Interest: 'Finance',
  Tax: 'Finance',
  'Income Tax': 'Finance',
  Pension: 'Finance',
  'Family transfer': 'Family',
  'Internal Transfer': 'Internal Transfers',
  Vault: 'Internal Transfers',
  Pocket: 'Internal Transfers',
  Savings: 'Internal Transfers',
  'Income (Enable Ireland)': 'Income',
  'Health Insurance Payout': 'Income',
  'Income (Lucena)': 'Income',
  'Rental Income (19Abb)': 'Investments (Property)',
  'Rental Income (51LC)': 'Investments (Property)',
  'Income (Evercam)': 'Income',
  'Income (AYLIEN)': 'Income',
  'Consultancy: Omar': 'Income',
  'Child Benefit': 'Income',
  '3GD Mortgage lump-sum': '3GD Mortgage lump-sum',
  'Tax-free Gift': 'Income',
  'Repayment from Family/Friends': 'Income',
  Repayment: 'Income',
  'Income (RRLtd)': 'Income',
  'Income (RRLtd Salary)': 'Income',
  'Investment (Crypto)': 'Investments (Finance)',
  Reward: 'Income',
  Refunds: 'Refunds',
  Reverted: 'Reverted',
  Unknown: 'Unknown',
};

export const displayHouseholdCategory = (category: string | null | undefined) => {
  const text = (category || '').trim();
  if (!text || text === 'Uncategorised') return CHART_UNKNOWN;
  if (text === 'Medical Insurance Payout') return 'Health Insurance Payout';
  if (text === 'Repayment from Family/Friends') return 'Repayment';
  if (text === 'Rental Income (Abberley)') return 'Rental Income (19Abb)';
  if (text === 'Mortgage (Abberley)') return 'Mortgage (19Abb)';
  if (text === 'RTB (19Abb)') return 'Other Expenses (19Abb)';
  if (text === 'RTB (51LC)') return 'Other Expenses (51LC)';
  if (text === 'RTB') return CHART_UNKNOWN;
  if (text === 'Income') return CHART_UNKNOWN;
  if (text === 'Topup') return CHART_UNKNOWN;
  if (text === 'Coffee' || text === 'Coffee Shop') return 'Cafe';
  if (text === 'Natural Medicine') return 'Medical (Natural)';
  return text;
};

export const groupNameOf = (
  category: string | null | undefined,
  groups: Record<string, string>
) => groups[displayHouseholdCategory(category)] || CHART_UNKNOWN;

export const cashflowOfCategory = (
  category: string | null | undefined,
  groups: Record<string, string>
) => {
  const group = groupNameOf(category, groups);
  if (group === CHART_INCOME) return CHART_INCOME;
  if (group === CHART_TRANSFERS) return CHART_TRANSFERS;
  if (group === CHART_INVESTMENTS_FINANCE) return CHART_INVESTMENTS_FINANCE;
  if (group === CHART_MORTGAGE_LUMP) return CHART_MORTGAGE_LUMP;
  if (
    group === CHART_INVESTMENTS_PROPERTY ||
    group === 'Investments' ||
    group === 'Investment (Property)'
  )
    return CHART_INVESTMENTS_PROPERTY;
  if (group === CHART_UNKNOWN) return CHART_UNKNOWN;
  return CHART_EXPENSES;
};

export const isInvestmentCashflow = (side: string | null | undefined) => {
  const text = (side || '').trim();
  return text === CHART_INVESTMENTS_PROPERTY || text === CHART_INVESTMENTS_FINANCE;
};

/** Cashflows that plot credits minus debits (Income vs Expenses on hover). */
export const isNettingCashflow = (side: string | null | undefined) => {
  const text = (side || '').trim();
  return text === CHART_INVESTMENTS_PROPERTY || text === CHART_MORTGAGE_LUMP;
};

/** 51LC / 19Abb from Mortgage (51LC) or Rental Income (19Abb). Abberley is 19Abb. */
const INVESTMENT_PROPERTY_CANONICAL: Record<string, string> = {
  abberley: '19Abb',
};

export const canonicalInvestmentProperty = (name: string) => {
  const text = (name || '').trim();
  return INVESTMENT_PROPERTY_CANONICAL[text.toLowerCase()] || text;
};

export const investmentPropertyOfCategory = (category: string | null | undefined) => {
  const match = /\(([^)]+)\)\s*$/.exec(displayHouseholdCategory(category));
  const raw = (match?.[1] || '').trim();
  return raw ? canonicalInvestmentProperty(raw) : '';
};

export const investmentPropertyNames = (groups: Record<string, string>) => {
  const names = new Set<string>();
  Object.entries(groups).forEach(([category, group]) => {
    if (group !== CHART_INVESTMENTS_PROPERTY) return;
    const property = investmentPropertyOfCategory(category);
    if (property) names.add(property);
  });
  return Array.from(names);
};

/** Chart names plus aliases such as Abberley so URL `cat=abberley` still filters 19Abb. */
export const investmentPropertyFilterNames = (groups: Record<string, string>) => {
  const names = new Set(investmentPropertyNames(groups));
  if (names.has('19Abb')) names.add('Abberley');
  return Array.from(names);
};

export const isInvestmentPropertyName = (
  filter: string | null | undefined,
  groups: Record<string, string>
) => {
  const text = displayHouseholdCategory(filter);
  if (!text || groups[text] === CHART_INVESTMENTS_PROPERTY) return false;
  return investmentPropertyNames(groups).includes(canonicalInvestmentProperty(text));
};

export const matchesHouseholdCategoryFilter = (
  category: string | null | undefined,
  filter: string | null | undefined,
  groups: Record<string, string>
) => {
  const want = displayHouseholdCategory(filter);
  if (!want) return true;
  const cat = displayHouseholdCategory(category);
  if (cat === want) return true;
  return (
    isInvestmentPropertyName(want, groups) &&
    investmentPropertyOfCategory(cat) === canonicalInvestmentProperty(want)
  );
};

export const rowMatchesHouseholdChartBars = (opts: {
  selected: string[];
  chartSide: string;
  chartGroup: string;
  cashflow: string;
  group: string;
  category: string;
  groups: Record<string, string>;
}) => {
  const selected = opts.selected.map((name) => String(name || '').trim()).filter(Boolean);
  if (!selected.length) return true;
  if (!opts.chartSide) return selected.includes(opts.cashflow);
  if (opts.chartSide && opts.cashflow !== opts.chartSide) return false;
  if (opts.chartSide === CHART_EXPENSES && !opts.chartGroup) {
    return selected.includes(opts.group);
  }
  return selected.some((name) => matchesHouseholdCategoryFilter(opts.category, name, opts.groups));
};

export type InvestmentPropertyChartRow = {
  name: string;
  value: number;
  count: number;
  byYear: Record<string, number>;
  countByYear: Record<string, number>;
};

type InvestmentPropertySource = {
  category?: string | null;
  proposed_category?: string | null;
  debit?: number | null;
  credit?: number | null;
  debit_amount?: number | null;
  credit_amount?: number | null;
  count?: number | null;
  posted_date?: string | null;
  byYear?: Record<string, number>;
  countByYear?: Record<string, number>;
};

const investmentPropertyCategoryKind = (category: string) => {
  const name = displayHouseholdCategory(category);
  if (/^Rental Income/i.test(name)) return 0;
  if (/^Mortgage/i.test(name)) return 1;
  if (/^Property fees/i.test(name)) return 2;
  if (/^LPT/i.test(name)) return 3;
  if (/^Other Expenses/i.test(name)) return 4;
  return 5;
};

/** One signed bar per category, grouped so each property's rent sits next to its mortgage. */
export const groupInvestmentPropertyChartRows = (
  rows: InvestmentPropertySource[]
): InvestmentPropertyChartRow[] => {
  const buckets = new Map<string, InvestmentPropertyChartRow>();
  rows.forEach((row) => {
    const category = displayHouseholdCategory(row.proposed_category || row.category) || 'Other';
    const current = buckets.get(category) || {
      name: category,
      value: 0,
      count: 0,
      byYear: {},
      countByYear: {},
    };
    const credit = Number(row.credit_amount ?? row.credit ?? 0);
    const debitAmt = Number(row.debit_amount ?? row.debit ?? 0);
    const signed = credit - debitAmt;
    const n = Number(row.count ?? 1);
    current.value += signed;
    current.count += n;
    const year = String(row.posted_date || '').replace(/T.*/, '').slice(0, 4);
    if (/^\d{4}$/.test(year)) {
      current.byYear[year] = (current.byYear[year] || 0) + signed;
      current.countByYear[year] = (current.countByYear[year] || 0) + n;
    }
    Object.entries(row.byYear || {}).forEach(([key, amount]) => {
      current.byYear[key] = (current.byYear[key] || 0) + Number(amount || 0);
    });
    Object.entries(row.countByYear || {}).forEach(([key, count]) => {
      current.countByYear[key] = (current.countByYear[key] || 0) + Number(count || 0);
    });
    buckets.set(category, current);
  });
  const propertyAbs = new Map<string, number>();
  Array.from(buckets.values()).forEach((row) => {
    const property = investmentPropertyOfCategory(row.name) || row.name;
    propertyAbs.set(property, (propertyAbs.get(property) || 0) + Math.abs(row.value));
  });
  return Array.from(buckets.values()).sort((left, right) => {
    const leftProperty = investmentPropertyOfCategory(left.name) || left.name;
    const rightProperty = investmentPropertyOfCategory(right.name) || right.name;
    if (leftProperty !== rightProperty) {
      const bySize = (propertyAbs.get(rightProperty) || 0) - (propertyAbs.get(leftProperty) || 0);
      if (bySize) return bySize;
      return leftProperty.localeCompare(rightProperty);
    }
    const byKind = investmentPropertyCategoryKind(left.name) - investmentPropertyCategoryKind(right.name);
    if (byKind) return byKind;
    return left.name.localeCompare(right.name);
  });
};

export type HouseholdCashflowRow = {
  id: number;
  proposed_category?: string | null;
  debit_amount?: number | null;
  credit_amount?: number | null;
  offset_of_id?: number | null;
};

/** IDs that are one side of an offset_of_id link (refund or internal transfer). */
export const pairedOffsetIds = <T extends { id: number; offset_of_id?: number | null }>(
  rows: T[]
) => {
  const ids = new Set<number>();
  rows.forEach((row) => {
    if (row.offset_of_id) {
      ids.add(row.id);
      ids.add(row.offset_of_id);
    }
  });
  return ids;
};

export const householdOffsetChipColor = (label: string): 'error' | 'info' | 'default' => {
  if (label === 'Refunded' || label.startsWith('Offsets ')) return 'error';
  if (
    label === 'Linked' ||
    label === 'Repaid' ||
    label === 'Reimbursed' ||
    label.startsWith('Linked ') ||
    label.startsWith('Repays ') ||
    label.startsWith('Claim ')
  ) {
    return 'info';
  }
  return 'default';
};

export const householdOffsetChipVariant = (label: string): 'filled' | 'outlined' =>
  label === 'Refunded' || label === 'Reimbursed' ? 'filled' : 'outlined';

/** True when the row moved money (a signed debit or credit). */
export const householdHasSignedAmount = (row: HouseholdCashflowRow) =>
  Number(row.debit_amount || 0) > 0 || Number(row.credit_amount || 0) > 0;

/**
 * Internal Transfer / Vault / Pocket / Savings stay Internal Transfers cashflow
 * for credits (and for linked pairs). Unmatched transfer-group debits stay Expenses.
 * Investment (Crypto) / NEXO SERVICES stay Investments (Finance).
 * B2L rent and mortgages stay Investments (Property).
 * Refunds and Reverted stay Expenses so credits reduce the spend total.
 * Rows with no debit and no credit are N/A (for example Revolut closing transactions).
 * When splitUnknown is true, Unknown credits are Income and Unknown debits are Expenses.
 */
export const cashflowOfRow = (
  row: HouseholdCashflowRow,
  groups: Record<string, string>,
  pairedIds: Set<number>,
  splitUnknown = false
) => {
  if (!householdHasSignedAmount(row)) return CHART_NA;
  const cat = displayHouseholdCategory(row.proposed_category);
  if (groupNameOf(cat, groups) === CHART_TRANSFERS) {
    if (pairedIds.has(row.id) || Number(row.credit_amount || 0) > 0) return CHART_TRANSFERS;
    return CHART_EXPENSES;
  }
  if (splitUnknown && groupNameOf(cat, groups) === CHART_UNKNOWN) {
    if (Number(row.credit_amount || 0) > 0) return CHART_INCOME;
    return CHART_EXPENSES;
  }
  return cashflowOfCategory(cat, groups);
};

/** Debit minus credit so refund/reverted credits reduce Expenses. */
export const expenseSignedAmount = (row: HouseholdCashflowRow) =>
  Number(row.debit_amount || 0) - Number(row.credit_amount || 0);

/** Expense chart groups only; Income / Transfers / Unknown show as blank like SeCo. */
export const expenseGroupOfCategory = (
  category: string | null | undefined,
  groups: Record<string, string>
) => {
  if (cashflowOfCategory(category, groups) !== CHART_EXPENSES) return '';
  return groupNameOf(category, groups);
};

export const expenseGroupOfRow = (
  row: HouseholdCashflowRow,
  groups: Record<string, string>,
  pairedIds: Set<number>,
  splitUnknown = false
) => {
  if (cashflowOfRow(row, groups, pairedIds, splitUnknown) !== CHART_EXPENSES) return '';
  return groupNameOf(row.proposed_category, groups);
};

export const allocationOfKind = (kind: string | null | undefined) => {
  const value = (kind || '').trim().toLowerCase();
  if (value === 'business') return 'Business';
  if (value === 'n/a' || value === 'na' || value === 'transfer' || value === 'income') return 'N/A';
  if (value === 'personal') return 'Personal';
  return 'Personal';
};

export const categoriesFromApi = (
  payload: { categories?: Array<{ name: string; group_name?: string }> } | null | undefined,
  fallback: Record<string, string>
) => {
  const next = { ...fallback };
  (payload?.categories || []).forEach((row) => {
    if (row?.name) next[row.name] = row.group_name || CHART_UNKNOWN;
  });
  return next;
};

/** Merchant text used to find similar household rows (trim + collapse spaces). */
export const similarSearchNeedle = (description: string | null | undefined) =>
  (description || '').replace(/\s+/g, ' ').trim();

export const normalizeHouseholdDescription = (description: string | null | undefined) =>
  similarSearchNeedle(description).toLowerCase();

const MIN_SIMILAR_SUBSTRING = 6;

export const descriptionsAreSimilar = (
  left: string | null | undefined,
  right: string | null | undefined
) => {
  const a = normalizeHouseholdDescription(left);
  const b = normalizeHouseholdDescription(right);
  if (!a || !b) return false;
  if (a === b) return true;
  if (a.length >= MIN_SIMILAR_SUBSTRING && b.includes(a)) return true;
  if (b.length >= MIN_SIMILAR_SUBSTRING && a.includes(b)) return true;
  return false;
};

/** Anchor first, then other loaded rows with a similar description. */
export const householdRowsSimilarTo = <T extends { id: number }>(
  rows: T[],
  anchor: T,
  descriptionOf: (row: T) => string
): T[] => {
  const needle = descriptionOf(anchor);
  if (!normalizeHouseholdDescription(needle)) return [anchor];
  const others = rows.filter(
    (row) => row.id !== anchor.id && descriptionsAreSimilar(needle, descriptionOf(row))
  );
  return [anchor, ...others];
};

/** Compact cashflow chip label so Internal Transfers does not dominate column width. */
export const displayCashflowLabel = (side: string | null | undefined) => {
  const text = (side || '').trim();
  if (text === CHART_TRANSFERS || text === 'Internal Transfer') return 'Int. Transf';
  if (text === CHART_INVESTMENTS_PROPERTY) return 'Inv. Property';
  if (text === CHART_INVESTMENTS_FINANCE) return 'Inv. Finance';
  if (text === CHART_MORTGAGE_LUMP) return '3GD Lump-sum';
  return text;
};

export const CASHFLOW_FILTER_OPTIONS = [
  CHART_INCOME,
  CHART_EXPENSES,
  CHART_TRANSFERS,
  CHART_INVESTMENTS_PROPERTY,
  CHART_INVESTMENTS_FINANCE,
  CHART_MORTGAGE_LUMP,
  CHART_UNKNOWN,
  CHART_NA,
] as const;

/** Open-detail row: mid blue fill plus a navy left bar so it stands out from selected/hover rows. */
export const OPEN_DETAIL_ROW_BG = '#64B5F6';
export const OPEN_DETAIL_ROW_HOVER_BG = '#42A5F5';
export const OPEN_DETAIL_ROW_ACCENT = '#0D47A1';
export const openDetailRowSx = {
  bgcolor: OPEN_DETAIL_ROW_BG,
  boxShadow: `inset 6px 0 0 ${OPEN_DETAIL_ROW_ACCENT}`,
  '&:hover': { bgcolor: OPEN_DETAIL_ROW_HOVER_BG },
  '&.Mui-selected': { bgcolor: OPEN_DETAIL_ROW_BG },
  '&.Mui-selected:hover': { bgcolor: OPEN_DETAIL_ROW_HOVER_BG },
  '& > .MuiTableCell-root': { bgcolor: 'inherit', fontWeight: 600 },
};

/** Keep filter names above the field so they do not sit on top of All years / All cashflows. */
export const householdFilterLabelSx = {
  position: 'relative' as const,
  transform: 'none',
  mb: 0.5,
  fontSize: '0.75rem',
  lineHeight: 1.2,
  color: 'text.secondary',
  maxWidth: 'none',
};

export const householdSortHeaderSx = {
  bgcolor: 'background.paper',
  textAlign: 'center' as const,
  '& .MuiTableSortLabel-root': {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
};
